<div class="house-views-readonly-card">
  <div class="card-header d-flex align-items-center justify-content-between"
       [class.section-disabled]="allDisabled">
    <div class="d-flex align-items-center">
      <mat-icon class="cursor-pointer me-2" (click)="collapsed = !collapsed">
        {{ collapsed ? 'chevron_right' : 'expand_more' }}
      </mat-icon>
      <strong>{{ label }}</strong>
    </div>
    <mat-slide-toggle color="primary"
      [checked]="masterEnabled"
      (change)="onMasterToggle($event)">
    </mat-slide-toggle>
  </div>

  <div class="card-body" *ngIf="!collapsed">
    <table class="table" *ngIf="views.length">
      <thead>
        <tr>
          <td>Object</td>
          <td class="text-end">Value</td>
          <td class="text-end">Confidence</td>
          <td class="text-center"></td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let v of views"
            [class.row-disabled]="enabledMap[getViewKey(v)] === false">
          <td>{{ getItemNames(v) }}</td>
          <td class="text-end number-col">{{ v.value * 100 | number:'1.0-2' }}%</td>
          <td class="text-end number-col">{{ v.confidence }}%</td>
          <td class="text-center">
            <mat-slide-toggle color="primary"
              [checked]="enabledMap[getViewKey(v)] !== false"
              (change)="onViewToggle(v, $event)">
            </mat-slide-toggle>
          </td>
        </tr>
      </tbody>
    </table>
    <p *ngIf="!views.length" class="text-muted text-center py-3">No views configured.</p>
  </div>
</div>
